<template>
  <NuxtLayout name="default">
    <AppError :error="error" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import AppError from '@/components/AppError';

defineProps<{
  error: NuxtError;
}>();
</script>
